import { render, staticRenderFns } from "./WalletConfirm.vue?vue&type=template&id=5c4d9c4f"
import script from "./WalletConfirm.vue?vue&type=script&lang=ts"
export * from "./WalletConfirm.vue?vue&type=script&lang=ts"
import style0 from "./WalletConfirm.vue?vue&type=style&index=0&id=5c4d9c4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports